import { render, staticRenderFns } from "./AddToShoppingListModal.vue?vue&type=template&id=584262d9&"
import script from "./AddToShoppingListModal.vue?vue&type=script&lang=ts&"
export * from "./AddToShoppingListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports